export const SHOW_SIDE_BAR='sidebar/SHOW_SIDE_BAR';